/* eslint-disable new-cap */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-lines-per-function */
import React, { useState } from 'react';
import { Modal, IconButton, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CloseSharpIcon from '@material-ui/icons/CloseSharp';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ListaLogs } from '../../services/tabelaPrecoApi/index';
import * as moment from 'moment';

import './style.css';

function rand() {
    return Math.round(Math.random() * 20) - 10;
}

const ModalLogEdicoesMensalidade = props => {
    const { id } = props;
    const [open, setOpen] = React.useState(false);
    const [logsEdicao, setLogsEdicao] = useState([]);

    async function BuscaLogs() {
        ListaLogs(id)
            .then(resp => {
                setLogsEdicao(resp);
            })
            .catch(err => {
                console.error('erro', err);
            });
    }

    logsEdicao.sort((a, b) => new Date(b.dataUpdate) - new Date(a.dataUpdate));

    let buscarPlano;

    for (const i in logsEdicao) {
        const idPlano = logsEdicao[i];

        buscarPlano = idPlano.plano;
    }

    const handleOpen = () => {
        setOpen(true);
        BuscaLogs();
    };

    const handleClose = () => {
        setOpen(false);
    };

    const usuarioBody = rowData => (
        <>
            <span className="p-column-title"> Editado por </span>
            {rowData['userAccessUpdated.AnalistaComercial.userUpdated']}
        </>
    );

    const dataBody = rowData => (
        <>
            <span className="p-column-title"> Data da edição </span>
            {moment(rowData.dataUpdate)
                .add(3, 'hours')
                .format('DD/MM/YYYY [às] HH:mm:ss')}
        </>
    );

    const valorBody = rowData => (
        <>
            <span className="p-column-title"> Valor </span>
            {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(rowData.valorBase)}
        </>
    );

    const body = (
        <div className="ModalStyle modalLogEdicoes">
            <IconButton
                className="fecharModal"
                variant="contained"
                size="small"
                onClick={handleClose}
            >
                <CloseSharpIcon />
            </IconButton>
            <Typography variant="h6" align="center" gutterBottom>
                Registro de Edições
            </Typography>
            <h3 style={{ color: '#000000' }}>
                Plano: <span style={{ color: '#373737' }}>{buscarPlano}</span>
            </h3>
            <br />
            <div className="dentroModalLog">
                <div className="datatable-responsive-demo">
                    <DataTable
                        className="p-datatable-responsive-demo"
                        value={logsEdicao}
                        rows={6}
                        paginator
                        emptyMessage="Nenhuma edição encontrada"
                    >
                        <Column
                            field="valor_base"
                            header="Valor Base"
                            body={valorBody}
                        ></Column>
                        <Column
                            field="userUpdated"
                            header="Editado por"
                            body={usuarioBody}
                        ></Column>
                        <Column
                            field="dataUpdate"
                            header="Data da edição"
                            body={dataBody}
                        ></Column>
                    </DataTable>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <IconButton
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleOpen}
            >
                <SearchIcon />
            </IconButton>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
};

export default ModalLogEdicoesMensalidade;
